export default __webpack_public_path__ + "static/media/list.8486a1e6.svg";